// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.18.1
//   protoc               v3.19.1
// source: xeam/common/workspace_area.proto

/* eslint-disable */

export const protobufPackage = "xeam.common";

export const protobufFileName = "xeam/common/workspace_area.proto";

export enum WorkspaceArea {
  UNSPECIFIED = 0,
  BATTERY = 1,
  PRICES = 2,
  METERING_POINT_CONSUMPTION = 3,
  ELECTRICITY_CONTRACT = 4,
  CAR = 5,
  INDOOR = 6,
}
